import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import './PageRaceAnunciantes.css';

function PageRaceAnunciantes() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="raceadv-page">
        <header className="raceadv-header">
          <button className="btn-back" onClick={() => navigate('/top25-anunciantes')}>
            &#8592; Top 25 Anunciantes
          </button>
          <div className="raceadv-title-block">
            <h1 className="raceadv-title">Top 25 Anunciantes — Race</h1>
            <p className="raceadv-subtitle">Inversión Publicitaria Últimos 12 Meses &middot; Honduras</p>
          </div>
        </header>

        <div className="raceadv-video-wrap">
          <video
            className="raceadv-video"
            controls
            autoPlay
            playsInline
          >
            <source
              src="https://presentation-hn-2025-q4.publisearch.net/race_chart_anunciantes_top25.mp4"
              type="video/mp4"
            />
            Tu navegador no soporta video HTML5.
          </video>
        </div>
      </div>
    </PageBackground>
  );
}

export default PageRaceAnunciantes;
